import { Dynamic } from "../../../controllers/conductor";
import { getController } from "../../../controllers/getter";
import { AlertDrawer } from "../../sections/sidebar/AlertDrawer";
import { LoadingAnimation } from "../../widgets/loading";
import { MainWindow } from "../MainWindow";
import { Button, IconButton } from "../../widgets/buttons";
import { ScrollingTable } from "../../widgets/table";
import { Blocker } from "../../widgets/misc";
import { AttractionsController } from "../../../controllers/Attractions";
import { LocationSelector } from "../../widgets/form";

function Attractions() {

    const ref = {
        lgu: "1",
        province: "1"
        // lgu: params.lguid,
        // province: params.provinceid
    };

    const controller = getController(AttractionsController, { ref });
    // if(controller.isInitialized) controller.changeDate(ref.month, ref.year);

    const { notifiers, status } = controller;
    
    return (<MainWindow currentTab="attractions">
        <Dynamic conductor={[ notifiers.ready, notifiers.unauthorized ]} child={()=>
            status.unauthorized ? <Unauthorized /> : status.ready ? <Main controller={controller} /> : <LoadingWindow />
        } />
    </MainWindow>);
}

function Unauthorized() {
    return <div>Unauthorized</div>;
}

function LoadingWindow() {
    return (<center><LoadingAnimation /> Loading...</center>);
}


function Main({ controller }) {
    return <div className="form-main">
        <div className="alert-drawer-wrapper"><AlertDrawer controller={controller.notifiers.alert} /></div>
        <Header controller={controller} />
        <ListSection controller={controller}/>
        <Footer controller={controller} />
    </div>;
}


function Header({ controller }) {
    const { province, lgu } = controller.reference;
    let locationValues = { province, lgu };

    return <header>
        <div>
            <h2>Tourist Attractions</h2>
            {/* <h5>{ `${lguName}, ${province} • ${date}` }</h5> */}
        </div>
        <div className="buttons" key={Math.random()} >
            <LocationSelector values={{ lgu, province }} collection={controller.collection} onChange={v => locationValues = v} />
            <Button color="blue" icon="filter" onClick={()=>controller.changeLocation(locationValues.province, locationValues.lgu)}>FILTER</Button>
        </div>
    </header>;
}



function ListSection({ controller }) {
    const columns = [
        { title: "NAME", width: "40%" },
        { title: "CATEGORY", width: "15%" },
        { title: "LOCATION", width: "30%" },
        { title: "", width: "15%" },
    ];

    const { notifiers, status } = controller;

    return <main>
        <Dynamic conductor={notifiers.reloaded} child={()=>{
            const { data } = controller;

            if(data.length === 0) return <center>No tourist attractions yet.</center>;

            const rows = data.map((attraction, ai) => {
                const { name, category, location } = attraction;

                return [
                    name,
                    category,
                    location,
                    <div style={{opacity: 0.7}}>
                        <IconButton size="30" icon="edit" onClick={()=>controller.editAttraction(attraction)} /> &nbsp; &nbsp; 
                        <IconButton size="30" icon="cancel" onClick={()=>controller.deleteAttraction(attraction)} />
                    </div>
                ];
            });

            return <ScrollingTable columns={columns} rows={rows} />;
        }} />
        <Dynamic conductor={notifiers.reloading} child={()=>
            <Blocker active={status.reloading}><center><LoadingAnimation />Loading data...</center></Blocker>
        } />
    </main>
}

function Footer({ controller }) {
    return <footer>
        <div>

        </div>
        <div>
            <Dynamic conductor={controller.notifiers.adding} child={()=>{
                const adding = controller.status.adding;
                const label = adding ? "ADDING..." : "ADD ATTRACTION";

                return <Button inProgress={adding} color="green" icon="add" onClick={() => controller.addAttraction()}>{label}</Button>;
            }} />
            
        </div>
    </footer>;
}



export default Attractions;